<template lang="html">
  <b-navbar type="faded" class="showLargeScreenOnly d-flex justify-content-between p-4 h-80px">
    <div class="d-flex">
      <b-navbar-brand href="#" class="py-4 p-xl-3">
        <img :src="imgVarsLong" @click="loadAccueil" alt="MoneyRoad" class="heritage-web-header largescreen">
        <!--<img :src="imgVarsShort" @click="loadAccueil" alt="MoneyRoad" class="heritage-web-header middlescreen">-->
      </b-navbar-brand>

      <b-navbar-nav class="m-auto" fill :key="resetMenu">
        <span v-if="!isDisabledItem(item)" v-for="(item, id) in menu">
          <div v-if="item.list" @mouseover="autoDropdown(true, 'dropdown' + id)" @mouseleave="autoDropdown(false, 'dropdown' + id)">
            <b-nav-item-dropdown v-if="hasOneRight(item.list)" :ref="'dropdown' + id" class="h5 font-weight-bold dropDownInnerWebHeader p-1 p-xl-2 pr-xl-4 mt-3" toggle-class="text-menu" :text="$t(item.title)">
              <b-dropdown-group>
                <b-dropdown-item v-for="subitem in item.list"
                  v-if="subitem.enabled && canShowSpecific(subitem) && !isDisabledItem(subitem)"
                  class="dropdown-item-web-header"
                  :class="subitem.id === 0 ? 'subItemMenuWebHeader' : 'subItemTextWebHeader'"
                  :key="subitem.id" @click="getClicked(subitem)">
                  {{ $t(subitem.title) }}
                  <span v-if="!subitem.link" class="disabled ml-1">{{ $t('common.dsbld') }}</span>
                </b-dropdown-item>
              </b-dropdown-group>
            </b-nav-item-dropdown>
          </div>
          <b-nav-item :disabled="isDisabledItem(item)" v-else-if="item.enabled"
            class="h5 text-menu subItemTextOnlyWebHeader p-1 p-xl-2 pr-xl-4 mt-3 font-weight-bold"
            :class="{selectedMenuItemWebHeader: selectedMenu === item.link}"
            link-classes="subItemLink"
            @click="getClicked(item)">
            {{ $t(item.title) }}
            <span v-if="!item.link" class="disabled ml-1">{{ $t('common.dsbld') }}</span>
            <!--DRO 03/07/2023 : Commenté l'attribut 'style'. Enlever les classes et remettre le style si nécessaire-->
            <div v-if="item.link == selectedMenu" class="border-success border-bottom pt-2" commented_style="border-bottom:1px solid var(--actionButtonColorBlue); padding-top:10px;"></div>
            <div v-else class="opacity-0 border-bottom pt-2" commented_style="padding-top:10px"></div>
          </b-nav-item>
        </span>
      </b-navbar-nav>
    </div>

    <!-- <b-navbar-nav fill>
      <input class="" style="border: 1px solid lightgrey;padding-left: 25px;width:300px;z-index:10;border-radius:10px;font-size:14px" placeholder="Recherche rapide...">
        <i class="fa-light fa-magnifying-glass" style="position: absolute;margin-top: 3px;z-index:10;margin-left:5px;font-size: 17px"></i>
      </input>
    </b-navbar-nav> -->

    <!-- Right Panel (user account information) -->
    <div class="d-flex justify-content-around">
      <b-navbar-nav fill class="mx-0 mx-lg-3">
        <div @mouseover="autoDropdown(true, 'log')" @mouseleave="autoDropdown(false, 'log')">
          <b-nav-item-dropdown v-if="this.$engine.user && this.$engine.user.userAccountId !== 1" ref="log" class="logOut" toggle-class="d-flex align-items-center" right variant="link">
            <template v-slot:button-content>
              <img class="navbarProfileImage mr-2" :src="imgProfil"/>
              <div class="d-flex flex-column align-items-start">
                <span class="d-none d-xl-inline mr-2 h5 mb-0 text-menu profile-menu"> <strong> {{ companyName }} </strong> </span>
                <span class="d-none d-xl-inline mr-2 mb-0 text-menu profile-menu">  {{ userName }} </span>
              </div>
            </template>
            <b-dropdown-item @click="goToLink('/profile/')" class="subItemTextWebHeader dropdown-item-web-header">{{ $t('leftPanelTitle.my_prfl') }}</b-dropdown-item>
            <b-dropdown-item v-if="hasMultipleAccounts()" @click="activateModalProfile" class="subItemTextWebHeader dropdown-item-web-header">{{ $t('leftPanelTitle.swtch_prfl') }}</b-dropdown-item>
            <b-dropdown-item v-if="$engine.rights.rightIs('settings_consulter',true)" @click="goToLink('/settings/application/')" class="subItemTextWebHeader dropdown-item-web-header">{{ $t('Webheader.settings') }}</b-dropdown-item>
            <!--<b-dropdown-item @click="logout" class="subItemTextWebHeader dropdown-item-web-header">{{ this.$t('leftPanelTitle.lgout') }}</b-dropdown-item> -->
          </b-nav-item-dropdown>
        </div>
      </b-navbar-nav>

      <b-navbar-nav fill class="mx-1 my-2 m-lg-2">
        <b-button variant="primary" class="px-2 px-lg-4 d-none-max-849px text-nowrap" @click="logout">
          <span class="d-none-max-1459px"> {{ $t('leftPanelTitle.lgout') }} </span>
          <i class="d-none-min-1460px fa fa-power-off fs-14px"></i>
        </b-button>
      </b-navbar-nav>

      <b-navbar-nav fill class="mx-0 mx-lg-3">
        <b-dropdown right toggle-class="border-0 p-0 bg-none m-md-2 text-dark" v-model="language">
          <template slot="button-content">
            <img class="flag-nav" :src="language === 'FR' ? logoFlagFR : logoFlagEN" /><span class="d-none-max-1459px mr-1">{{ labelLanguage }}</span>
          </template>
          <b-dropdown-item v-for="option in options" :key="option.value" class="dropdown-item-web-header" @click="languageCountry(option.value)">
            <img class="flag-nav" v-if="option.value === 'FR'" :src="logoFlagFR"/>
            <img class="flag-nav" v-else :src="logoFlagEN"/>
            <span>{{option.text}}</span>
          </b-dropdown-item>
        </b-dropdown>
      </b-navbar-nav>
    </div>
  </b-navbar>
</template>

<script>
import ProfileImage from './../../assets/static/images/image-profile2.png'
import FlagFRImage from './../../assets/static/images/fr.png'
import FlagENImage from './../../assets/static/images/gb.png'
import {loadPage, reloadPage2} from './../../helpers/routing'
import CompanyTheme from './../../helpers/companyTheme.json'
import Services from '@/helpers/services'
import design from '@/design/design.json'

/* Remettre dans menu.json après la démo du 26/02 (quand on pourra prendre le temps
* de mettre des droits sur les fournisseurs) :
{
  "id": 7,
  "title": "Homepage.create_supplier",
  "link": "/suppliers/create/",
  "enabled": true,
  "service": 8
},
{
  "id": 8,
  "title": "Webheader.my_suppliers",
  "link": "/inbox/",
  "enabled": true,
  "service": 8
},
{
  "id": 9,
  "title": "Webheader.verifications",
  "link": "/verifications/SIREN/",
  "enabled": true,
  "service": 8
} **/
/* Barre de navigation sur grands écran (ordinateurs), et liens contenus dans celle-ci */
export default {
  name: 'WebHeader',
  props: {
    context: {
      default: 'generic',
      type: String
    }
  },
  data () {
    return {
      companyId: 0,
      companyName: '',
      companyTheme: CompanyTheme,
      logoProfile: ProfileImage,
      logoFlagFR: FlagFRImage,
      logoFlagEN: FlagENImage,
      menu: {},
      menuLinkList: null,
      userName: '',
      accountType: 0,
      design: design.menu,
      selectedMenu: '',
      languageLabel: 'Français',
      resetMenu: false,
      language: '',
      options: []
    }
  },
  created () {
    this.language = this.$i18n.locale.toUpperCase()
    this.options = [
      { value: 'FR', text: this.$t('lang.french')},
      { value: 'EN', text: this.$t('lang.english')}
    ]
    if (this.context && this.context !== 'generic') {
      this.menuLinkList = require('./data/menu_' + this.context + '.json')
    } else {
      this.menuLinkList = require('./data/menu.json')
    }
    if (this.$engine.user.get().name != null) {
      this.companyName = this.$engine.user.get().name
    }
    this.getUsername()
    this.accountType = this.$engine.user.get().type
    this.companyId = this.$engine.user.get().id
    this.setMenuItems()
    this.$bus.$on('refresh-cache-menu', () => {
      this.companyName = this.$engine.user.get().name
      this.accountType = this.$engine.user.get().type
      this.setMenuItems()
    })
    let that = this
    this.$bus.$off('reset-selected-menu')
    this.$bus.$on('reset-selected-menu', function () {
      that.selectedMenu = ''
      let elem = document.getElementsByClassName('selectedMenuItemWebHeader').item(0)
      if (elem) {
        elem.classList.remove('selectedMenuItemWebHeader')
      }
      that.resetMenu = !that.resetMenu
    })
    this.$bus.$on('switch-selected-menu', function(newUrl) {
      that.selectedMenu = newUrl
    })
    this.selectedMenu = this.$f7.getCurrentView().url
  },
  mounted () {
  },
  computed: {
    imgVarsLong () {
      return this.design.headbandLogoLong
    },
    imgVarsShort () {
      return this.design.headbandLogoShort
    },
    imgProfil () {
      return this.design.headbandProfilePic
    },
    labelLanguage () {
      let lang = this.language
      let langOpt = this.options.filter(elem => elem.value.toLowerCase() === lang.toLowerCase())
      let label = this.$t('lang.french')
      if (langOpt.length) {
        label = langOpt[0].text
      }
      return label
    }
  },
  methods: {
    canShowSpecific (subItem) {
      if ((subItem.link === '/rights/profiles/') && this.$engine.user.get().type === '2') {
        return false
      }
      return true
    },
    getUsername () {
      let info = this.$engine.accounts.get()
      let userAccounts
      let userAccountId

      userAccounts = info[0].userAccts
      userAccountId = info[0].userAccountId
      userAccounts = userAccounts.filter((account) => account.id === userAccountId)
      this.updateUsername(userAccounts)
    },
    hasOneRight (itemList) {
      let that = this
      return itemList.filter(item => {
        return !that.isDisabledItem(item)
      }).length
    },
    setMenuItems () {
      this.menu = this.menuLinkList['linkContent']
      // compter le nombre de pages dispo
      let nbPage = 0
      let link = ''
      let that = this
      this.menu.forEach((item, index) => {
        if (item.list && item.list.length) {
          if (that.hasOneRight(item.list) && !that.isDisabledItem(item)) {
            item.list.forEach((subitem, subindex) => {
              if (subitem.enabled && that.canShowSpecific(subitem) && !that.isDisabledItem(subitem)) {
                nbPage++
                link = subitem.link
              }
            });
          }
        } else if (item.enabled && !that.isDisabledItem(item)) {
          nbPage++
          link = item.link
        }
      })

      if (nbPage === 1 ) {
        reloadPage2(that, link)
      }
    },
    logout () {
      this.$bus.emit('logout')
    },
    activateModalProfile () {
      this.$f7.popup('#switch-profile-true')
    },
    goToLink (linkToGo) {
      this.selectedMenu = ''
      this.$f7.mainView.router.load({url: linkToGo, reload: true})
    },
    getClicked (subitem) {
      switch (subitem.link) {
        case '/directPayments/creation/':
          this.$bus.$emit('service:change', 'Direct Payments')
          this.$bus.$emit('direct-inbox-filtered', 1)
          this.$engine.user.changeService(this.$engine.services.getServiceById(Services.DIRECTPAYMENTS))
          this.$engine.user.currentService.id = Services.DIRECTPAYMENTS
          break
        case '/payments/newPayments/':
          this.$bus.$emit('service:change', 'Payments')
          this.$bus.$emit('direct-debit-filtered', 1)
          this.$engine.user.changeService(this.$engine.services.getServiceById(Services.PAYMENTS))
          this.$engine.user.currentService.id = Services.PAYMENTS
          break
        case '/directDebit/creation/':
          this.$bus.$emit('service:change', 'Direct Debit')
          this.$bus.$emit('inbox-filtered', 1)
          this.$engine.user.changeService(this.$engine.services.getServiceById(Services.DIRECTDEBIT))
          this.$engine.user.currentService.id = Services.DIRECTDEBIT
          break
        case '/businessDocument/sendForm/':
        case '/businessDocument/requestForm/':
          this.$bus.$emit('service:change', 'Business Documents')
          this.$bus.$emit('inbox-filtered', 1)
          this.$engine.user.changeService(this.$engine.services.getServiceById(Services.DOCUMENTSERVICE))
          this.$engine.user.currentService.id = Services.DOCUMENTSERVICE
          break
        case '/suppliers/create/':
          this.$bus.$emit('service:change', 'Suppliers')
          this.$bus.$emit('inbox-filtered', 1)
          this.$engine.user.changeService(this.$engine.services.getServiceById(Services.SUPPLIERS))
          this.$engine.user.currentService.id = Services.SUPPLIERS
          break
        case String(subitem.link.match('^/inbox/.*')):
          switch (subitem.service) {
            case 1:
              this.$bus.$emit('service:change', 'Payments')
              this.$bus.$emit('direct-debit-filtered', 1)
              this.$engine.user.changeService(this.$engine.services.getServiceById(Services.PAYMENTS))
              this.$engine.user.currentService.id = Services.PAYMENTS
              break
            case 2:
              this.$bus.$emit('service:change', 'Direct Debit')
              this.$bus.$emit('inbox-filtered', 1)
              this.$engine.user.changeService(this.$engine.services.getServiceById(Services.DIRECTDEBIT))
              this.$engine.user.currentService.id = Services.DIRECTDEBIT
              break
            case 6:
              this.$bus.$emit('service:change', 'Direct Payments')
              this.$bus.$emit('direct-inbox-filtered', 1)
              this.$engine.user.changeService(this.$engine.services.getServiceById(Services.DIRECTPAYMENTS))
              this.$engine.user.currentService.id = Services.DIRECTPAYMENTS
              break
            case 7:
              this.$bus.$emit('service:change', 'Business Documents')
              this.$bus.$emit('inbox-filtered', 1)
              this.$engine.user.changeService(this.$engine.services.getServiceById(Services.DOCUMENTSERVICE))
              this.$engine.user.currentService.id = Services.DOCUMENTSERVICE
              break
            case 8:
              this.$bus.$emit('service:change', 'Suppliers')
              this.$bus.$emit('inbox-filtered', 1)
              this.$engine.user.changeService(this.$engine.services.getServiceById(Services.SUPPLIERS))
              this.$engine.user.currentService.id = Services.SUPPLIERS
              break
            case 9:
              this.$bus.$emit('service:change', 'Verifications')
              this.$bus.$emit('inbox-filtered', 1)
              this.$engine.user.changeService(this.$engine.services.getServiceById(Services.VERIFICATIONS))
              this.$engine.user.currentService.id = Services.VERIFICATIONS
              break
            default:
            /*  "Tous les services", à reprendre plus tard
            {id: 4, title: 'Webheader.all_usages', link: '/inbox/'} */
              break
          }
          break
        default:
          break
      }
      let that = this
      this.selectedMenu = subitem.link
      reloadPage2(that, subitem.link)
    },
    getBackground () {
      if (this.companyTheme[this.companyId] && this.companyTheme[this.companyId].background) {
        return 'background: ' + this.companyTheme[this.companyId].background
      }
    },
    getLargeLogo () {
      if (this.companyTheme[this.companyId] && this.companyTheme[this.companyId].logoLarge) {
        return './../../assets/static/images/logo/' + this.companyTheme[this.companyId].logoLarge
      } else {
        return require('./../../assets/static/images/logo/moneyroad_white_green.png')
      }
    },
    getMiddleLogo () {
      if (this.companyTheme[this.companyId] && this.companyTheme[this.companyId].logoMiddle) {
        return './../../assets/static/images/logo/' + this.companyTheme[this.companyId].logoMiddle
      } else {
        return require('./../../assets/static/images/logo/mrlogo.png')
      }
    },
    hasMultipleAccounts () {
      let accounts = this.$engine.accounts.get()
      let diffAccounts = []
      accounts.forEach(account => {
        if (!diffAccounts.includes(account.id)) {
          diffAccounts.push(account.id)
        }
      })
      return diffAccounts.length > 1
    },
    loadAccueil () {
      var that = this
      this.selectedMenu = ''
      // loadPage(that, {url: '/home/' + that.context})
      loadPage(that, {url: '/home/'})
    },
    goToLoginPage () {
      var that = this
      loadPage(that, {url: '/login/'})
    },
    autoDropdown (value, id) {
      Object.keys(this.$refs).forEach((item) => {
        if (item === id) {
          if (this.$refs[item][0]) {
            this.$refs[item][0].visible = value
          } else {
            this.$refs[item].visible = value
          }
        }
      })
    },
    isDisabledItem (item) {
      if (item && !item.enabled) {
        return true
      }
      if (item && item.right_disable && item.right_disable.right) { // If item has a right value
        if (item.right_disable.right === 'rights_profile_consult') {
          return this.$engine.user.get().id === this.$engine.user.get()
          ? this.$engine.rights.rightIs('rights_admin_consulter', item.right_disable.state)
          : this.$engine.rights.rightIs(item.right_disable.right, item.right_disable.state)
        }
        // Return true if the right has the same state as the disabling state
        return this.$engine.rights.rightIs(item.right_disable.right, item.right_disable.state)
      }
      return false
    },
    languageCountry (language) {
      this.language = language
      if (language === 'EN') {
        this.$i18n.locale = 'en'
      } else {
        this.$i18n.locale = 'fr'
      }
      this.options = [
        { value: 'FR', text: this.$t('lang.french')},
        { value: 'EN', text: this.$t('lang.english')}
      ]
    },
    updateUsername (userAccount) {
      this.userAccountInfo = userAccount
      this.userName = this.userAccountInfo[0].name
    }
  }

}
</script>

<style>

</style>
